// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var StrategySubscriptionStatus;
(function (StrategySubscriptionStatus) {
    StrategySubscriptionStatus[StrategySubscriptionStatus["NotAccepted"] = 0] = "NotAccepted";
    StrategySubscriptionStatus[StrategySubscriptionStatus["Accepted"] = 1] = "Accepted";
    StrategySubscriptionStatus[StrategySubscriptionStatus["Deleted"] = 2] = "Deleted";
})(StrategySubscriptionStatus || (StrategySubscriptionStatus = {}));
